const SET_APP = 'app/SET_APP';

export default {
  SET_APP,
};
